import {
  ALL_SHIPPINGS,
  ADD_NEW_SHIPPING,
  UPDATE_SHIPPING,
  DELETE_SHIPPING,
  FETCH_SHIPPINGS_BY_USER,
  FETCH_SHIPPING,
  START_LOADING,
  END_LOADING,
} from '../actions/constants'

const shipping = (state = { isLoading: true, shippings: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true }
    case END_LOADING:
      return { ...state, isLoading: false }
    case ALL_SHIPPINGS:
      return { ...state, shippings: action.payload }
    case FETCH_SHIPPINGS_BY_USER:
      return { ...state, shippings: action.payload }
    case FETCH_SHIPPING:
      return { ...state, shipping: action.payload.shipping }
    case ADD_NEW_SHIPPING:
      return { ...state, shippings: [...state.shippings, action.payload] }
    case UPDATE_SHIPPING:
      return {
        ...state,
        shippings: state.shippings.map((item) => (item.id === action.payload.id ? action.payload : item)),
      }
    case DELETE_SHIPPING:
      return { ...state, shippings: state.shippings.filter((item) => item.id !== action.payload) }
    default:
      return state
  }
}

export default shipping
